import React from 'react';
import './WHMCS.css';

const WHMCSInstall = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>نصب و کانفیگ WHMCS | خدمات حرفه‌ای نصب WHMCS | افراسل</h1>
        <p>نصب و راه‌اندازی حرفه‌ای WHMCS روی سرورهای لینوکس و ویندوز. شامل کانفیگ امنیتی، تنظیمات بهینه و نصب قالب و ماژول‌های مورد نیاز.</p>
        <meta name="description" content="نصب و کانفیگ حرفه‌ای WHMCS با بهترین تنظیمات و پشتیبانی ۲۴ ساعته." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              ⚙️ نصب و کانفیگ WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              نصب و کانفیگ <em>WHMCS</em>
            </h1>
            <p className="whmcs-hero-desc">
              نصب و راه‌اندازی WHMCS یک فرآیند تخصصی است که نیاز به دانش فنی و تجربه دارد. تیم افراسل با سال‌ها تجربه در نصب و کانفیگ WHMCS، این سرویس را با بهترین تنظیمات برای شما راه‌اندازی می‌کند. شامل نصب کامل، کانفیگ امنیتی، تنظیمات بهینه سرور، نصب قالب و ماژول‌های مورد نیاز و پشتیبانی ۲۴ ساعته.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">حرفه‌ای</span>
                <span className="stat-label">نصب کامل</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              نصب <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با نصب حرفه‌ای WHMCS توسط تیم افراسل، از بهترین تنظیمات و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>درخواست خدمات</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCSInstall;
